import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { colors } from "@/theme/colors";

// ラベル + 本文の 1 ブロック。空文字の項目は表示しない。label 省略時は本文のみ表示する。
function ContentBlock({ label, value }: { label?: string; value: string }) {
  if (!value) return null;
  return (
    <Box sx={{ mb: 2 }}>
      {label && (
        <Typography sx={{ color: colors.textMuted, fontSize: 14, fontWeight: 600, mb: 0.5 }}>
          {label}
        </Typography>
      )}
      <Typography sx={{ color: colors.textBody, fontSize: 15, whiteSpace: "pre-line" }}>
        {value}
      </Typography>
    </Box>
  );
}

type Props = {
  description: string;
  includedInCost: string;
  notIncludedInCost: string;
  meetingPlaceAddress: string;
};

/**
 * 商品内容 (説明・費用に含まれるもの/含まれないもの・集合場所) を divider で区切って表示する。
 */
export function CourseContentSections({
  description,
  includedInCost,
  notIncludedInCost,
  meetingPlaceAddress,
}: Props) {
  const { t } = useTranslation();
  const hasCostInfo = Boolean(includedInCost) || Boolean(notIncludedInCost);
  return (
    <Box>
      {/* 説明本文は Prime 入稿時に Biz 側がタイトルを含めているため、
          ラベルの重複を避けて本文のみ表示する (JPTP_CANSEI-1532)。 */}
      <ContentBlock value={description} />
      {description && hasCostInfo && <Divider sx={{ my: 2 }} />}
      <ContentBlock label={t("courseDetail.includedInCost")} value={includedInCost} />
      <ContentBlock label={t("courseDetail.notIncludedInCost")} value={notIncludedInCost} />
      {(description || hasCostInfo) && meetingPlaceAddress && <Divider sx={{ my: 2 }} />}
      <ContentBlock label={t("courseDetail.meetingPlaceAddress")} value={meetingPlaceAddress} />
    </Box>
  );
}
